import React, { useState, useRef, useEffect, useField } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

import Select from "react-select";
import { baseURL } from "../../config";

function IniatiateAppraisalForm() {
  const selectInputRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [departmentsData, setDepartmentsData] = useState(null);
  const [options, setOptions] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [employeeinitalsdata, setEmployeesInitialData] = useState([]);
  const [assigneevalues, setAssigneeValues] = useState(null);
  const [selassigneevalues, setSelAssigneeValues] = useState(null);
  const [modifiedAssignees, setModifiedAssignees] = useState("");
  const [assigneeids, setAssigneeIds] = useState([]);
  const [selectedDepartmentid, setSelctedDepartmentid] = useState(null);
  const [designation, setDesignation] = useState(0);
  const [seldepartment, setSelDepartment] = useState(0);
  const [allemployees, setAllEmployees] = useState([]);
  const [progress, setProgress] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showToastError, setshowToastError] = useState(false);

  const [isdeptselected, setIsDeptselected] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const navigate = useNavigate();
  const [terms, setTerms] = useState({ midYear: true, endOfYear: false });
  const [alreadyIniated, setAlreadyIniated] = useState(false);
  const [alreadyInitiatedMsg, setAlreadyInitiatedMsg] = useState(null);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const nextYear = currentYear + 1;

  const handleRemoveAllOptions = () => {
    setAllEmployees([]);
  };
  let deptid = "All";
  let desigid = 0;

  const [value, setValue] = useState([]);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${baseURL}/getdepartments`);
        setOptions(response.data.departments);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
    //  fetchDesignations();
  }, []);

  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const response = await axios.get(`${baseURL}/getallassigneesfromuser`);
        setAllEmployees(response.data.employees);
        setEmployeesInitialData(response.data.employees);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
    setSelctedDepartmentid("All");
    fetchDesignations();
    // deisgnationChange("All");
    deptid = "All";
  }, []);

  const fetchDesignations = async () => {
    try {
      const resp = await axios.get(`${baseURL}/getdeignations`);
      if (resp.statusText === "OK") {
        setDesignationData(resp.data.designations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const departmentChange = async (dempartmentid) => {
    try {
      deptid = dempartmentid;

      const resp = await axios.get(
        `${baseURL}/getdesignationsbydepartment?deptid=` + deptid
      );
      if (resp.statusText === "OK") {
        let designations = resp.data.designations;
        setDesignationData(designations);
        setSelctedDepartmentid(dempartmentid);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    // getEmployeesforDepartment(dempartmentid);
    deisgnationChangebyDept(dempartmentid);
  };
  const getEmployeesforDepartment = async (did) => {
    try {
      //alert("getEmployeesforDepartment");

      const resp = await axios.get(
        `${baseURL}/getAllassigneesbydesignationandept?did=` + did + "&id=All"
      );
      if (resp.statusText === "OK") {
        //alert("after axios selected designation:"+designation);
        setEmployeesData(resp.data.employees);

        setEmployeesInitialData(resp.data.employees);
        let assignees = resp.data.employees
          .map((employee) => employee.id)
          .join(",");
        setAssigneeValues(assignees);
        setModifiedAssignees(assignees);
        setSelectedOptions(assignees);
        //  setIsDeptselected(true)
        //   alert(assignees);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const deisgnationChange = async (designationid) => {
    try {
      // deisgnationChangebyDept()
      //alert(designationid);
      desigid = designationid;

      console.log("inside designation change desigid.." + desigid);
      console.log("inside designation change designationid.." + designationid);
      let selecteddesignation = designationid;
      //alert("selected  designation"+selecteddesignation);
      setDesignation(selecteddesignation);
      //selectInputRef.isMulti=true;
      if (designationid === "0") {
        selectInputRef.current.clearValue();

        return;
      }

      const resp = await axios.get(
        `${baseURL}/getAllassigneesbydesignationandept?id=` +
          designationid +
          "&did=" +
          selectedDepartmentid
      );
      if (resp.statusText === "OK") {
        //alert("after axios selected designation:"+designation);
        setEmployeesData(resp.data.employees);

        setEmployeesInitialData(resp.data.employees);
        let assignees = resp.data.employees
          .map((employee) => employee.id)
          .join(",");
        setAssigneeValues(assignees);
        setModifiedAssignees(assignees);
        setIsDeptselected(true);
        //   alert(assignees);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const deisgnationChangebyDept = async (deptid) => {
    try {
      //alert(designationid);

      //alert("selected  designation"+selecteddesignation);
      //     setDesignation(selecteddesignation);

      //selectInputRef.current.clearValue();

      const resp = await axios.get(
        `${baseURL}/getassigneesbydesignationandept?id=All` + "&did=" + deptid
      );
      if (resp.statusText === "OK") {
        //alert("after axios selected designation:"+designation);
        setEmployeesData(resp.data.employees);

        setEmployeesInitialData(resp.data.employees);
        let assignees = resp.data.employees
          .map((employee) => employee.id)
          .join(",");
        setAssigneeValues(assignees);
        setModifiedAssignees(assignees);
        setIsDeptselected(true);
        //   alert(assignees);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const getValue = () => {
    console.log("==================");
    console.log("designation" + designation);
    let newopt = [];
    console.log("department" + deptid);
    if (designation === "All" && deptid == "All") {
      console.log("================== inside all all");
      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
      }));
    } else if (designation !== "All" && designation != "0" && deptid == "All") {
      console.log("================== inside desig !all dept all");
      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
      }));
    }
    if (selectedOptions && selectedOptions.length > 0) {
      return selectedOptions;
    } else if (isdeptselected) {
      if (deptid != "All") {
        console.log("================== inside desig !all dept all");
        newopt = employeeinitalsdata.map((employee) => ({
          value: employee.id,
          label: `${employee.FirstName} ${
            employee.LastName !== null ? employee.LastName : ""
          } - ${employee.employeeid}`,
        }));
      }
    } else {
      return [];
    }
    return newopt;
  };
  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleTermChange = (e) => {
    const { name, checked } = e.target;
    let periodval = "";

    if (checked && name === "midYear") {
      setTerms({
        midYear: true,
        endOfYear: false,
      });
      periodval = `April ${selectedYear}`;
    } else if (checked && name === "endOfYear") {
      setTerms({
        midYear: false,
        endOfYear: true,
      });
      periodval = `December ${selectedYear}`;
    } else {
      setTerms({
        midYear: false,
        endOfYear: false,
      });
    }

    setAlreadyInitiatedMsg("");
    setAlreadyIniated(false);
    if (periodval) {
      checkIfAlreadyInitiated(periodval, seldepartment);
    }
  };

  const checkIfAlreadyInitiated = async (periodval, departmentval) => {
    try {
      const resp = await axios.post(
        `${baseURL}/checkAssigneesifAppraisalInitiated`,
        {
          department: departmentval,
          period: periodval,
        }
      );

      // Handle the response
      if (resp.status >= 200) {
        const data = resp.data;
        if (data.exists) {
          setAlreadyIniated(true);
          setAlreadyInitiatedMsg(data.message);
          return 1;
        } else return 0;

        // Handle the response data as needed
      } else {
        return 0;
        console.error("Error:", resp.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);
      let response;
      // let isApprInitiated= checkIfAlreadyInitiated(formData["period"],formData["departmentid"]);

      const resp = await axios.post(
        `${baseURL}/checkAssigneesifAppraisalInitiated`,
        {
          department: formData["departmentid"],
          period: formData["period"],
        }
      );
      if (resp.status >= 200) {
        const data = resp.data;
        if (data.exists) {
          setAlreadyIniated(true);
          setAlreadyInitiatedMsg(data.message);
          setShowModal(false);
          return;
        } else {
          response = await axios.post(`${baseURL}/initiateappraisal`, formData);
          if (response.status === 202) {
            // Reset form data and close modal after successful submission
            setFormData(null);
            setShowModal(false);
            setShowToast(true);
            setTimeout(() => {
              setShowToast(false);
               navigate('/dashboard');
            }, 3000);

            // Redirect to the desired page
            // window.location.href = "/Initiateappraisal";
          }
        }

        // Handle the response data as needed
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const getFirstDayOftheYear = (year) => `${year}-01-01`;
  const getLastDayOftheYear = (year) => `${year}-12-31`;

  function getLastDayOfYear(date) {
    const year = selectedYear;
    // const lastDay = new Date(year, 12, 31);
    let lastDay = new Date();
    lastDay.setFullYear(year);
    lastDay.setMonth(11, 31); // December is 11 in JavaScript
    return lastDay.toISOString().substr(0, 10);
  }
  function resetOptions() {}

  const handleYearChange = (event) => {
    const nextSelectedYear = Number(event.target.value);
    const nextPeriod = terms.midYear
      ? `April ${nextSelectedYear}`
      : terms.endOfYear
      ? `December ${nextSelectedYear}`
      : "";

    setSelectedYear(nextSelectedYear);
    setAlreadyInitiatedMsg("");
    setAlreadyIniated(false);

    if (nextPeriod) {
      checkIfAlreadyInitiated(nextPeriod, seldepartment);
    }
  };

  const appraisalPeriod = terms.midYear
    ? `April ${selectedYear}`
    : terms.endOfYear
    ? `December ${selectedYear}`
    : "";

  return (
    <>
      <Formik
        initialValues={{
          departmentid: "",
          startdate: "",
          enddate: "",
          enableReinitialize: true,
          designation: "All",
          assignees: "",
          period: "",
        }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          resetForm,
        }) => (
          <div className="container">
            <div className="row">
              <h4 className="text-start pb-2 col-md-4">Initiate Appraisal </h4>
              <div className="col-md-12">
                <div className="row">
                  <label className="col-md-5">
                    Select Year:{" "}
                    <select value={selectedYear} onChange={handleYearChange}>
                      <option value={currentYear}>{currentYear}</option>
                      <option value={nextYear}>{nextYear}</option>
                    </select>
                  </label>
                  <div className="col-md-2"></div>
                </div>
              </div>
            </div>

            <div className="col-lg-12  mt-1 m-5">
              <form  onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5">
                    <label>
                      Select Department <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      name="departmentid"
                      value={(values.departmentid = selectedDepartmentid)}
                      onChange={(e) => {
                        //handleRemoveAllOptions();
                        departmentChange(e.target.value);
                        setSelDepartment(e.target.value);
                        deisgnationChange("All");
                      }}
                    >
                      <option value="All">All Departments</option>
                      {options.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.departmentname}
                        </option>
                      ))}
                    </select>
                    {touched.departmentid && errors.departmentid ? (
                      <div className="text-danger">{errors.departmentid}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5  ml-5 ">
                    <label>Start Date</label>
                    <br />
                    <input
                      type="date"
                      className="form-control"
                      name="startdate"
                      required
                      onChange={handleChange}
                      defaultValue={values.startdate}
                    ></input>
                  </div>

                  <div className="col-lg-5 mt-2 ">
                    <label>End Date</label>
                    <br />
                    <input
                      type="date"
                      required
                      className="form-control"
                      name="enddate"
                      onChange={handleChange}
                      defaultValue={
                        values.enddate || getLastDayOftheYear(selectedYear)
                      }
                    ></input>
                  </div>

                  <div class="col-lg-5 mt-3 ml-5">
                    <label>Select Designation</label>
                    <input
                      type="hidden"
                      name="designationid"
                      value={(values.designation = designation)}
                    />
                    <select
                      className="form-select form-control"
                      name="role"
                      placeholder="Select Designation"
                      value={(values.role = designation)}
                      onChange={(e) => {
                        handleRemoveAllOptions();
                        desigid = e.target.value;
                        setDesignation(e.target.value);
                        deisgnationChange(e.target.value);
                        console.log("==onchnage==" + e.target.value);
                        console.log("==onchnage==" + desigid);
                      }}
                    >
                      <option value={0}>Select Designation</option>
                      <option value="All" selected>
                        All Designations
                      </option>
                      {designationData.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.designation}
                        </option>
                      ))}
                    </select>
                    {touched.designation && errors.designation ? (
                      <div className="text-danger">{}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-2 ">
                    <label>
                      Select Assignees <span className="text-danger"></span>
                    </label>
                    <Select
                      ref={selectInputRef}
                      isMulti
                      name="assignees2"
                      options={employeeinitalsdata.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${
                          employee.LastName !== null ? employee.LastName : ""
                        } - ${employee.employeeid}`,
                      }))}
                      value={getValue()}
                      onChange={(selectedOptions) => {
                        // setAssigneevalues(selectedValues.join(","));
                        setSelectedOptions(selectedOptions);

                        let finalIds = selectedOptions
                          .map((employee) => employee.value)
                          .join(",");
                        setAlreadyInitiatedMsg("");
                        setAlreadyIniated(false);

                        setModifiedAssignees(finalIds);
                        setFieldValue("assignees", finalIds);
                        setFieldValue("assignees2", finalIds);
                        setIsDeptselected(false);
                        //  isassigneeselected(true);
                      }}
                    />

                    {alreadyIniated ? (
                      <label style={{ color: "red" }}>
                        {" "}
                        <br /> {alreadyInitiatedMsg}
                      </label>
                    ) : null}

                    {touched.assignees && errors.assignees ? (
                      <div className="text-danger">{errors.assignees}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 ml-5 mt-3">
                    <h6>SELECT TERM</h6>
                    <div className="form-check">
                      <Field
                        className="form-check-input"
                        type="radio"
                        id="midYear"
                        name="midYear"
                        checked={terms.midYear}
                        onChange={handleTermChange}
                        value={terms.midYear}
                      />
                      <label className="form-check-label" htmlFor="midYear">
                        Mid Year
                      </label>
                    </div>
                    <div className="form-check">
                      <Field
                        className="form-check-input"
                        type="radio"
                        id="endOfYear"
                        name="endOfYear"
                        checked={terms.endOfYear}
                        onChange={handleTermChange}
                        value={terms.endOfYear}
                      />
                      <label className="form-check-label" htmlFor="endOfYear">
                        End of Year
                      </label>
                    </div>
                  </div>

                  <input
                    type="hidden"
                    name="assignees"
                    //employeeinitalsdata.map((employee) => employee.id).join(",")
                    value={
                      (values.assignees = modifiedAssignees
                        ? modifiedAssignees
                        : null)
                    }
                  />
                  <input
                    type="hidden"
                    value={modifiedAssignees}
                    name="modifiedassignees"
                  ></input>
                  <div className="col-lg-5 mt-3">
                    <span className="vfont fs">Initiate Appraisal Period:</span>
                    <p
                      className="fs-5 bluefont fw-bold"
                      id="currentyear"
                      name="period"
                      value="period"
                    >
                      {appraisalPeriod}
                    </p>

                    <Field
                      type="hidden"
                      name="period"
                      onChange={(e) => {
                        //handleRemoveAllOptions();
                        //alert("period"+e.target.value)
                        //checkIfAlreadyInitiated(e.target.value)
                      }}
                      value={(values.period = appraisalPeriod)}
                    />
                  </div>
                </div>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/dashboard">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>{" "}
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToastError}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">X</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>
              Appraisal for this period was already iniiated. Please try with
              different period
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default IniatiateAppraisalForm;
